import { render, staticRenderFns } from "./App.vue?vue&type=template&id=35d37248&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/styles.css?vue&type=style&index=0&id=35d37248&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d37248",
  null
  
)

export default component.exports